<template>
  <div>
    <v-form
      ref="form"
      :lazy-validation="true"
    >

      <v-row>
        <v-col cols="4">
          <v-text-field
            data-cy="firstName"
            v-model="apprenticeLocal.firstName"
            label="Förnamn *"
            outlined
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            data-cy="lastName"
            outlined
            v-model="apprenticeLocal.lastName"
            label="Efternamn *"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            class
            outlined
            data-cy="personalNumber"
            v-model="apprenticeLocal.personalNumber"
            label="Personnummer *"
            :rules="[rules.required, rules.integer, rules.hasLength(12, apprenticeLocal.personalNumber), rules.swePnr]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            outlined
            data-cy="mobilephone"
            v-model="apprenticeLocal.mobilephone"
            label="Mobiltelefon *"
            :rules="[rules.required, rules.phone]"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            data-cy="email"
            v-model="apprenticeLocal.email"
            label="E-post *"
            outlined
            :rules="[rules.required, rules.email]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-text-field
            outlined
            data-cy="adress"
            v-model="apprenticeLocal.address1"
            label="Adress"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            data-cy="adress2"
            v-model="apprenticeLocal.address2"
            label="Adress (rad 2)"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            outlined
            data-cy="postnummer"
            v-model="apprenticeLocal.zip"
            label="Postnummer"
            :rules="[rules.integer, rules.hasLength(5, apprenticeLocal.zip)]"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            data-cy="ort"
            v-model="apprenticeLocal.city"
            label="Ort"
            outlined
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import API from '@/services/api.js'
import pick from 'lodash/pick'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ApplicationApprenticeEdit',

  props: {
    apprentice: {
      type: Object,
      required: true
    }
  },

  model: {
    prop: 'apprentice',
    event: 'change-apprentice'
  },

  mixins: [RulesMixin],

  mounted() {
    if (this?.$refs?.addressbox) {
      this.$refs.form.reset()
      this.$refs.addressbox.$refs.form.reset()
    }
  },

  computed: {
    apprenticeLocal: {
      get() {
        return this.apprentice
      },

      set(value) {
        this.$emit('change-apprentice', value)
      }
    }
  },

  watch: {
    // @vuese
    //- Make sure any changes in vuex state is reflected in this.state
    selectedApplication: {
      handler() {
        this.apprentice = pick(this.selectedApplication, this.columns)
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),

    /**
     * @vuese
     * Used to update application if the form is valid or create a new one if an application exist already
     * @arg The argument is an integer representing application  id and param is the apprentice object
     */
    saveChangeApprentice() {
      console.log('ApplicationApprentice - saveChangeApprentice')
      //- Trigger validations and bug out on invalid
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      if (this.apprenticeLocal.id) {
        // @vuese
        //-Update Application
        API.updateApplication(this.apprenticeLocal.id, {data: this.apprenticeLocal})
          .then(response => {
            this.updateSelectedApplication(this.apprenticeLocal)
            this.$events.fire('showInfo', 'Sparad.')
            this.$emit('save')
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      } else {
        //- Add state (for creating)
        this.apprenticeLocal.stateId = this.selectedApplication.stateId
        //- Create new application
        API.createApplication({data: this.apprenticeLocal})
          .then(response => {

            /**
             * @vuese
             * Used to update selected application in local store with the new application created
             */
            console.log('Created!', response.data.id)
            this.$events.fire('showInfo', 'Anmälan skapad.')
            this.$router.push({path: `/applications/${response.data.id}`})

            // Emit event up to parent to set "editing" to false.
            this.$emit('save')
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      }
    },

    cancelChangeApprentice() {
      console.log('ApplicationApprentice - cancelChangeApprentice')
      this.apprenticeLocal = pick(this.selectedApplication, this.columns)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>